"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getFresh = () => [
    {
        id: "10000",
        login: "demo@almfactory.com",
        email: "demo@almfactory.com",
        password: "test0",
    },
    {
        id: "10002",
        login: "demo1@almfactory.com",
        email: "demo1@almfactory.com",
        password: "test1",
    },
    {
        id: "10003",
        login: "demo2@almfactory.com",
        email: "demo2@almfactory.com",
        password: "test2",
    },
    {
        id: "10004",
        login: "test",
        email: "test",
        password: "test",
    },
];
exports.default = () => {
    return getFresh();
};
//# sourceMappingURL=users.js.map